import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  label?: string;
}

export function Spinner({ label, className, ...rest }: SpinnerProps) {
  return (
    <span className={clsx('spinner', className)} role={label ? 'status' : undefined} {...rest}>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
